import { authApiService } from '@/api/authApiService';
import { UpdateInvitedUserPayloadType, UpdateInvitedUserResponseType } from '@/api/types';
import { ApiResponseType } from '@/types/sharedTypes';

export type UpdateRecipientResponseType = UpdateInvitedUserResponseType & {
  recipient: {
    id: string;
  };
};

export const updateRecipientApi = (
  wireId: string,
  userId: string,
  data: UpdateInvitedUserPayloadType
): Promise<ApiResponseType<UpdateRecipientResponseType>> => {
  const uri = `/organization/wires/${wireId}/recipients/users/${userId}/`;

  return authApiService.PATCH(uri, data);
};
